import React from 'react';
import { t } from 'c-3po';

// styles
import css from './notification.sss';


export const ClientDisableChat = () => (
    <div className={css.root} data-qaid='ban_notification_block'>
        <div className={css.text} data-qaid='ban_notification'>
            {t`Вы не можете вести диалог в чате с этим продавцом,
                так как у него отключен прием сообщений из чата.
                Свяжитесь с ним другим доступным способом связи.`}
        </div>
    </div>  
)